import React from 'react';
import styled from 'styled-components';
import Layout from "../../../basic/Layout/Layout.js";
var StyledContent = styled.p.withConfig({
  componentId: "CL__sc-1ftrd48-0"
})(["flex-grow:1;overflow-wrap:anywhere;"]);
var StyledCTAWrapper = styled.div.withConfig({
  componentId: "CL__sc-1ftrd48-1"
})(["flex-shrink:0;max-width:156px;overflow:hidden;text-overflow:ellipsis;"]);
var InnerLayout = _ref => {
  var {
    content,
    cta
  } = _ref;
  return /*#__PURE__*/React.createElement(Layout, null, /*#__PURE__*/React.createElement(StyledContent, null, content), cta && /*#__PURE__*/React.createElement(StyledCTAWrapper, null, cta));
};
export default InnerLayout;